export const BASE_API_URL = 'https://adminapi-r3kp5jc53q-ts.a.run.app/api';
// export const BASE_API_URL = 'http://127.0.0.1:8000/api';

export const Endpoint = {
    LOGIN: `${BASE_API_URL}/auth/login`,
    GET_USER_INFOR: `${BASE_API_URL}/auth/me`,
    LOOKUP_ZIPCODE: `${BASE_API_URL}/lookup-zipcode`,
}
